<div class="empty-state m-auto justify-between align-items-center">
  <!-- <img
    [src]="imageSource"
    style="height: 20vh; width: 20vh; position: relative; left: 43% ;" 
  /> -->
  <h3 class="text-center">{{ message }}</h3>
</div>
